<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { ORDER_STATUS } from '@/constants/orderStatus'
import { useBoostCorePermissionStore } from '@/stores/useBoostCorePermissionStore'

const props = defineProps<{ params: { data?: { status?: string; uuid?: string } } }>()
const router = useRouter()
const boostCoreStore = useBoostCorePermissionStore()

const buttonLabel = computed(() =>
  props.params?.data?.status === ORDER_STATUS.VALIDATED || boostCoreStore.isProjectRead ? 'Voir' : 'Editer',
)

const href = computed(() => {
  const uuid = props.params?.data?.uuid
  return uuid ? `/dashboard/order/${uuid}` : null
})

function onClick(e: MouseEvent) {
  if (!href.value) return
  e.preventDefault()
  if (e.ctrlKey || e.metaKey) {
    window.open(href.value, '_blank')
  } else {
    router.push(href.value)
  }
}
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <a
      v-if="href"
      :href="href"
      class="btn btn-sm btn-ghost"
      @click="onClick"
    >{{ buttonLabel }}</a>
  </div>
</template>
